import request from '@/utils/request'

// 查询动态类型列表
export function listArticleType(query) {
  return request({
    url: '/h5/articleType/list',
    method: 'get',
    params: query
  })
}
